import React, { useState, useEffect } from 'react';

const StarRating = React.memo(({ score = 0, label, remarks }) => {
  return (
    <div className="form-group">
      <label className="label">{label}</label>
      <div className="star-with-remarks">
        {/* Display stars as readonly */}
        <div className="star-rating">
          {[...Array(10)].map((_, index) => {
            const value = index + 1;
            return (
              <span
                key={value}
                className={`star ${value <= score ? "filled" : ""}`}
                style={{
                  cursor: 'not-allowed',
                  color: value <= score ? '#ffc107' : '#ccc',
                  fontSize: '20px',
                  marginRight: '2px'
                }}
              >
                ★
              </span>
            );
          })}
        </div>

        {/* Readonly remarks input */}
        {remarks !== undefined && (
          <input
            type="text"
            value={remarks || ''}
            readOnly
            className="star-input"
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            placeholder={`Remarks for ${label.toLowerCase()}`}
          />
        )}
      </div>
    </div>
  );
});

const PerformanceSection = ({ formData, isExpanded = true }) => {
  const [mockCount, setMockCount] = useState(0);

  useEffect(() => {
    const count = [1, 2, 3].filter(i => formData[`mockTest${i}Score`] != null).length;
    setMockCount(count);
  }, [formData]);

  return (
    <div className="form-section">
      {isExpanded && (
        <div className="section-content">

          {/* Technical and Communication Scores */}
          <div className="form-row">
            <StarRating
              score={formData.technicalScore}
              label="Technology Score"
              remarks={formData.technologyRemarks}
            />
            <StarRating
              score={formData.communicationScore}
              label="Communication Score"
              remarks={formData.communicationRemarks}
            />
          </div>

          {/* Mock Test Scores */}
          <div className="form-row">
            {[...Array(mockCount)].map((_, index) => {
              const i = index + 1;
              return (
                <div className="mock-score-wrapper" key={i} style={{ marginRight: '20px' }}>
                  <StarRating
                    score={formData[`mockTest${i}Score`] || 0}
                    label={`Mock Test ${i} Score`}
                  />
                </div>
              );
            })}
          </div>

          {/* Mock Interview Section */}
          <div className="form-row">
            <div className="form-group">
              <label className="label">Mock Interview</label>
              <input
                type="text"
                value={formData.mockInterview || ''}
                readOnly
                className="input"
                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
              />
            </div>

            {formData.mockInterview === "Yes" && (
              <div className="form-group">
                <label className="label">Mock Interview Remarks</label>
                <input
                  type="text"
                  value={formData.mockRemarks || ''}
                  readOnly
                  className="input"
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PerformanceSection;
